import { useNavigate } from "react-router-dom";

const CertificateItem = (props) => {
    let certificate = props.certificate;
    let index = props.index;
    const navigate = useNavigate();

    function viewCertificate() {
        navigate("ViewCertificate?pdfName=" + certificate.name); // This will navigate one step back in the browser's history
    };

    return (
        <>
        <div className={"card h-100 certificate-item"} key={index} >
            <div className='card-container'>
                <div className='details-block'>
                    <div className="title-block">
                        <span className='certificate-title'>{certificate.name}</span>
                    </div>
                    <div className="date-block">
                        <span>Completed on: <div style={{ color: "green" }}>{certificate.certifiedOn}</div></span>
                    </div>
                </div>
                <div className="button-block member-info-section">
                    <div className="btn-group">
                        <button className="btn btn-primary" onClick={viewCertificate}>View Certificate</button>
                    </div>
                </div>
            </div>
        </div>
        </>
    );
}

export default CertificateItem;